import { createContext, useContext, useEffect, useState } from "react";

type Customer = any;

const AuthCustomerContext = createContext<{
  customer: Customer | null;
  setCustomer: (c: Customer | null) => void;
}>({
  customer: null,
  setCustomer: () => {},
});

export const AuthCustomerProvider = ({ children }: { children: React.ReactNode }) => {
  const [customer, setCustomer] = useState<Customer | null>(() => {
    const stored = localStorage.getItem("customer");
    return stored ? JSON.parse(stored) : null;
  });

  useEffect(() => {
    if (customer) {
      localStorage.setItem("customer", JSON.stringify(customer));
    } else {
      localStorage.removeItem("customer");
    }
  }, [customer]);

  return (
    <AuthCustomerContext.Provider value={{ customer, setCustomer }}>
      {children}
    </AuthCustomerContext.Provider>
  );
};

export const useAuthCustomer = () => useContext(AuthCustomerContext);